import { GetBoardTC } from './dashboard.thunk'

export const dashboardAsyncActions = {
  GetBoardTC,
}
